import React from 'react'
import { type ImmediatelyStore } from 'shared/ui/Schedule/ui/Immediately/store/immediatelyStore'
import { ImmediatelyContext } from './context/immediatelyContext'
import { ImmediatelyContent } from './ui/ImmediatelyContent'

type IImmediatelyProps = {
  store: ImmediatelyStore
}

export const Immediately = ({ store }: IImmediatelyProps) => {
  return (
    <ImmediatelyContext.Provider value={store}>
      <ImmediatelyContent />
    </ImmediatelyContext.Provider>
  )
}
